<template>
    <div class="content-body">
        <div class="row">
            <div class="col-12">
                <div class="top__header">
                    <span class="back" @click="back()">
                        <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M15.7071 5.79289C16.0976 6.18342 16.0976 6.81658 15.7071 7.20711L10.4142 12.5L15.7071 17.7929C16.0976 18.1834 16.0976 18.8166 15.7071 19.2071C15.3166 19.5976 14.6834 19.5976 14.2929 19.2071L8.29289 13.2071C7.90237 12.8166 7.90237 12.1834 8.29289 11.7929L14.2929 5.79289C14.6834 5.40237 15.3166 5.40237 15.7071 5.79289Z" fill="black"/>
                        </svg>
                    </span>
                    <div v-if="prospect">
                        <span class="header__title">{{ prospect.last_name ? prospect.last_name : ''+' '+prospect.first_name ? prospect.first_name : '' }}</span>
                        <span style="color: black" class="badge badge-pill badge-light" v-if="prospect.status == null">Nouveau</span>
                        <span class="badge badge-pill badge-success" v-if="prospect.status == '1'">Activé</span>
                        <span class="badge badge-pill badge-danger" v-if="prospect.status == '0'">Rejeté</span>
                    </div>
                    <div class="header__btn" v-if="prospect && prospect.status != '1' && connected!=3">
                        <button @click="showModal()" class="btn btn-primary">Changer le statut</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="card__suggestion" v-if="prospect">
            <h3>Informations client</h3>
            <div class="first__bloc mb-2 mt-2">
                <div>
                    <div><strong>Nom</strong></div>
                    <span>{{ prospect.last_name }}</span>
                </div>
                <div>
                    <div><strong>Prénom(s)</strong></div>
                    <span>{{ prospect.first_name }}</span>
                </div>
                <div>
                    <div><strong>Téléphone</strong></div>
                    <span><a class="__color" target="_blank" :href="`https://wa.me/+228`+prospect.phone">{{ prospect.phone }}</a></span>
                </div>
            </div>
            <div class="second__bloc mb-2">
                <div>
                    <div><strong>Email</strong></div>
                    <span><a class="__color" :href="mailTo">{{ prospect.email }}</a></span>
                </div>
                <div>
                    <div><strong>Adresse</strong></div>
                    <span>{{ prospect.address }}</span>
                </div>
                <div>
                    <div><strong>Personne à contacter en cas d’urgence</strong></div>
                    <span>{{ prospect.contact_person_full_name ? prospect.contact_person_full_name : ''+ '('+prospect.contact_person_number ? prospect.contact_person_number : ''+')' }}</span>
                </div>
            </div>
            <div class="last__bloc">
                <div><strong>Date de création du compte</strong></div>
                <p>{{ prospect.created_at }}</p>
            </div>
        </div>

        <div v-if="!prospect" class="alert alert-warning mt-2" role="alert">
            <div class="alert-body">Prospect/Client non trouvé ou données invalides.</div>
        </div>
        <div v-if="prospect && prospect.subscription && prospect.subscription.length > 0" class="card__suggestion">
            <h3>Liste des souscriptions ({{ prospect.subscription.length }})</h3>
            <div v-for="(item, key) in prospect.subscription" :key="key" class="subscription__section mb-2 mt-2">
                <div>
                    <div><strong>Produit</strong></div>
                    <span>{{ item.product.name }}</span>
                </div>
                <div>
                    <div><strong>Montant(Fcfa)</strong></div>
                    <span>{{ $format(item.amount) }}</span>
                </div>
                <div>
                    <div><strong style="color:#EA5455">Niveau de progression</strong></div>
                    <span>{{ getStatus(item.step, item.product_id, item.data.type_engin) }}</span>
                </div>
                <div>
                    <div><strong>Statut</strong></div>
                    <div>
                        <span v-if="item.status === 'negotiated' && item.amount_negotiated !== null" class="badge badge-pill badge-info">Négocié</span>
                        <span v-if="item.status === 'paid'" class="badge badge-pill badge-success">Payé</span>
                        <span v-if="item.status === 'negotiated' && item.amount_negotiated === null" class="badge badge-pill badge-info">En négociation</span>
                        <span v-if="item.status === 'save'" style="color: #0b2e13" class="badge badge-pill badge-light">Sauvegardé</span>
                    </div>
                </div>
                <div>
                    <button @click="$router('/administration/souscriptions/show/'+item.uuid)" type="button" class="btn btn-outline-primary btn-block">Voir détails</button>
                </div>
            </div>
            <hr>
        </div>

        <div class="modal fade text-left" id="changeStatus" tabindex="-1" role="dialog" aria-labelledby="myModalLabel1" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title" id="myModalLabel1">Changer le statut</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Statut</label>
                                    <select class="form-control" v-model="status">
                                        <option :selected="item.id == prospect.status" :disabled="item.id == prospect.status" v-for="(item, key) in options" :key="key" :value="item.id">{{ item.name }}</option>
                                    </select>
                                    <div v-if="errors.status" style="color: red">{{ errors.status[0] }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="status == '0'">
                            <div class="col-12">
                                <div class="form-group">
                                    <label>Motif du rejet</label>
                                    <textarea class="form-control" v-model="comment"></textarea>
                                    <div v-if="errors.comment" style="color: red">{{ errors.comment[0] }}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <button @click="changeStatus()" type="button" :disabled="disabledBtn" :class="disabledBtn ? 'disabled' : ''" class="btn btn-primary btn-block">Valider</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var $this;
import axios from 'axios';
import { api } from '../../../helpers/shared'
export default {
    props: ['detail','connected_user_profile'],
    data: () => ({
        prospect: {},
        errors: [],
        loading: false,
        status: null,
        comment: '',
        mailTo: '',
        connected:'',
        options: [
            {name: 'Nouveau', id: null},
            {name: 'Actif', id: '1'},
            {name: 'Rejeté', id: '0'}
        ]
    }),
    mounted(){
        this.prospect = JSON.parse(this.detail);
        this.connected = JSON.parse(this.connected_user_profile);
        this.mailTo = 'mailto:'+this.prospect.email;
        //console.log("VALEUR DE THIS.connected:",this.connected)
    },
    created(){
        $this = this
    },
    computed:{
        disabledBtn(){
            return this.prospect.status == this.status || this.loading == true;
        }
    },
    methods:{
        back(){
            if(window.location.href.includes('customers')){
                this.$router('/administration/customers')
            } else {
                this.$router('/administration/prospects')
            }
        },
        getStatus(status, product_id, type){
            if (product_id == '1'){
                if(type == '1'){
                    if (status <= 2) {
                        return 'Saisie des informations';
                    }else return 'Visualisation des résultats';
                }else{
                    if (status == '1'){
                        return 'Saisie des informations';
                    }else return 'Visualisation des résultats';
                }
            }
            if (product_id == '2' || product_id == '3'){
                if (status < 2) {
                    return 'Saisie des informations';
                }else return 'Visualisation des résultats';
            }
        },
        changeStatus(){
            this.loading = true;
            axios.post(api('administration/prospects'), {id: this.prospect.id, status: this.status, comment: this.comment})
            .then((response) => {
                this.loading = false;
                this.errors = [];
                this.$document('#changeStatus').modal('hide')
                this.prospect.status = this.status;
                if (response.data.status){
                    this.$toasted.global.all()
                }
            }).catch((error) => {
                this.loading = false;
                if (error.response.status === 401){
                }else {
                    this.errors = error.response.data.errors
                }
            })
        },
        showModal(){
            this.status = this.prospect.status;
            this.errors = [];
            this.$document('#changeStatus').modal('show')
        }
    }
}
</script>

<style lang="scss" scoped>
    .header__title{
        font-size: 22px;
        line-height: 30px;
        color: #5E5873;
    }
    .back{
        cursor: pointer;
    }
    .top__header {
        display: grid;
        grid-template-columns: 30px 1fr 1fr;
        .header__btn {
            justify-self: end;
        }
    }
    .card__suggestion{
        padding: 20px;
        height: auto;
        background: #FFFFFF;
        box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);
        border-radius: 6px;
        margin-top: 20px;
        .first__bloc{
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: 5px;
        }
        .second__bloc{
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            grid-gap: 5px;
        }
    }
    .subscription__section{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
        grid-gap: 5px;
    }
    .__color{
        color: #001E5F !important;
    }
</style>
